module.exports = __webpack_public_path__ + "static/size-c2ae54dbaee6277982465d01da0c14ff.png";